import { Button, Tooltip, Typography } from "@mui/material";
import { GridActionsCellItem, GridCellParams, GridColDef } from "@mui/x-data-grid";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import EditRoad from "@mui/icons-material/EditRoad";
import { useEffect, useMemo, useState } from "react";
import DataTable from "../../DataGrid/DataGrid";
import { useImmer } from "use-immer";
import EmployeeBiodataFormModal from "./EmployeeBiodataFormModal";
import { getLocalStorage } from "../../../Utils/storage-utils";
import dayjs from "dayjs";
import moment from "moment";
import { History } from "@mui/icons-material";
import axios from "axios";
import { APP_BASE_URL, MCDO_EMPLOYEE_BIODATA } from "../../../Common/EndPoints";
import { useNavigate } from "react-router-dom";
import EmployeeBioDataFilter from "./EmployeeBiodataFilter/EmployeeBiodataFilter";
import toast from "react-hot-toast";
import ViewInfoPopup from "../ViewInfoPopup";
import { extractFilters, OverflowTip } from "../helpers";

export const employeeBiodataFixedColumns: GridColDef[] = [
  {
    field: "name",
    headerName: "Employee Name",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
    valueGetter: (params) => {
      return params.row?.firstName || "" || params.row?.lastName || "";
    },
    filterable: false,
  },
  {
    field: "designation",
    headerName: "Designation",
    sortable: true,
    minWidth: 100,
    hideable: true,
    flex: 1,
  },
  {
    field: "groupOfEmployee",
    headerName: "Group of Employee",
    sortable: true,
    minWidth: 150,
    hideable: true,
    flex: 1,
    renderCell: (params) => {
      return params.value ?? "-";
    },
  },
  {
    field: "lastPromotionDate",
    headerName: "Last Promotion/MACP Date",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter: (params) => {
      const last_promotion_date = params.value;
      return last_promotion_date ? moment(last_promotion_date).format("DD/MM/YYYY") : "-";
    },
    filterable: false,
    sortComparator: (d1, d2) => {
      return dayjs(d1, "DD/MM/YYYY").isBefore(dayjs(d2, "DD/MM/YYYY")) ? -1 : 1;
    },
  },
  {
    field: "postCode",
    headerName: "Post Code",
    sortable: true,
    minWidth: 90,
    hide: true,
    hideable: false,
    flex: 1,
  },
  {
    field: "billUnit",
    headerName: "Bill Unit",
    sortable: true,
    minWidth: 90,
    hideable: true,
    flex: 1,
    hide: true,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "pfNo",
    headerName: "PF No.",
    sortable: true,
    flex: 1,
    minWidth: 130,
    hideable: true,
  },
  {
    field: "payBand",
    headerName: "Pay Band",
    sortable: false,
    flex: 1,
    minWidth: 130,
    hideable: true,
  },
  {
    field: "gradePay",
    headerName: "Grade Pay",
    sortable: true,
    flex: 1,
    minWidth: 130,
    hideable: true,
  },
  {
    field: "payLevel",
    headerName: "Pay Level",
    sortable: true,
    flex: 1,
    minWidth: 130,
    hideable: true,
  },
  {
    field: "basicPay",
    headerName: "Basic Pay",
    sortable: true,
    flex: 1,
    minWidth: 130,
    hideable: true,
  },
  {
    field: "taRate",
    headerName: "TA Rate",
    sortable: true,
    flex: 1,
    minWidth: 130,
    hideable: true,
  },
  {
    field: "workPosition",
    headerName: "Work Position",
    sortable: true,
    flex: 1,
    minWidth: 130,
    hideable: true,
  },
  {
    field: "revenueWorkchargePost",
    headerName: "Revenue / Workcharge post",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
  },
  {
    field: "umidNo",
    headerName: "Umid No.",
    sortable: true,
    minWidth: 150,
    flex: 1,
    hideable: true,
    hide: true,
  },
  {
    field: "hrmsId",
    headerName: "HRMS ID",
    sortable: true,
    minWidth: 150,
    flex: 1,
    hideable: true,
    hide: true,
  },
  {
    field: "aadharNo",
    headerName: "Aadhar No.",
    sortable: true,
    minWidth: 140,
    flex: 1,
    hideable: true,
    hide: true,
  },
  {
    field: "covidVaccination",
    headerName: "Covid Vaccination",
    sortable: true,
    minWidth: 140,
    flex: 1,
    hideable: true,
  },

  {
    field: "filledUpVacantDowngraded",
    headerName: "Filled up / Vacant / Downgraded",
    sortable: true,
    type: "string",
    flex: 1,
    minWidth: 220,
    hideable: true,
  },
  {
    field: "dpqDrq",
    headerName: "DPQ/DRQ",
    sortable: true,
    minWidth: 150,
    flex: 1,
    hideable: true,
  },
  {
    field: "gradeOfIncumbent",
    headerName: "Grade of Incumbent",
    sortable: true,
    minWidth: 180,
    flex: 1,
    hideable: true,
  },
  {
    field: "dob",
    headerName: "Date of Birth",
    sortable: true,
    minWidth: 120,
    flex: 1,
    hideable: true,
    renderCell: (row) => {
      const dob = row.value;
      return dob ? moment(dob).format("DD/MM/YYYY") : "-";
    },
    filterable: false,
  },
  {
    field: "doa",
    headerName: "Date of Appointment",
    sortable: true,
    minWidth: 150,
    flex: 1,
    hideable: true,
    valueGetter: (row) => {
      return row.value ? moment(row.value).format("DD/MM/YYYY") : "-";
    },
    filterable: false,
  },
  {
    field: "totalageasondate",
    headerName: "Total Age as on date",
    sortable: true,
    minWidth: 120,
    flex: 1,
    // hide: true,
    hideable: true,
    valueGetter: (value) => {
      const dob = value.row?.dob;
      if (dob) {
        return dayjs().diff(dob, "years").toString();
      }
      return "";
    },
    filterable: false,
    sortComparator: (d1, d2) => Number(d1) - Number(d2),
  },
  {
    field: "Age55Yearattended",
    headerName: "Age 55 Year attended (Yes/No)",
    sortable: true,
    minWidth: 120,
    flex: 1,
    hide: true,
    hideable: true,
    valueGetter: (value) => {
      const dob = value.row?.dob;
      if (dob) {
        return dayjs().diff(dob, "years") > 55 ? "Yes" : "No";
      }
      return "-";
    },
    filterable: false,
  },
  {
    field: "initialPlaceOfPosting",
    headerName: "Initial Place of posting with date",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter: (params) => {
      const row = params.row;
      return `${row?.initialPlaceOfPosting || "-"}, ${row?.initialDateOfPosting ? moment(row?.initialDateOfPosting).format("DD/MM/YYYY") : "-"
        }`;
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
    filterable: false,
  },
  {
    field: "previousPlaceOfPosting",
    headerName: "Previous Place of posting with date",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter: (params) => {
      const row = params.row;
      return `${row?.previousPlaceOfPosting || "-"}, ${row?.previousPlaceOfPostingDate ? moment(row?.previousPlaceOfPostingDate).format("DD/MM/YYYY") : "-"
        }`;
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
    filterable: false,
  },
  {
    field: "currentPlaceOfPosting",
    headerName: "Current Place of posting with date",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter: (params) => {
      const row = params.row;
      return `${row?.currentPlaceOfPosting || "-"}, ${row?.currentPlaceOfPostingDate ? moment(row?.currentPlaceOfPostingDate).format("DD/MM/YYYY") : "-"
        }`;
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
    filterable: false,
  },
  {
    field: "atSamePlaceSince",
    headerName: "At same place Since",
    sortable: true,
    minWidth: 120,
    flex: 1,
    hideable: true,
  },
  {
    field: "punishment",
    headerName: "Punishment",
    sortable: true,
    minWidth: 180,
    flex: 1,
    hideable: true,
    valueGetter: (params) => {
      const punishment = params.value;
      return punishment && Array.isArray(punishment)
        ? punishment
          .map(
            ({ date, reason, typeOfPunishment = "-", typeOfPenalty = "-" }: any, idx) =>
              `${idx + 1}) ${moment(date).format("DD/MM/YYYY")}, ${typeOfPunishment} ${typeOfPenalty}`,
          )
          .join("\n")
        : "-";
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
    filterable: false,
  },
  {
    field: "award",
    headerName: "Awards",
    sortable: true,
    minWidth: 120,
    flex: 1,
    hideable: true,
    valueGetter: (row) => {
      const awards = row.value;
      return awards && Array.isArray(awards)
        ? awards.map(({ name, date }) => `${name}, ${date ? dayjs(date).format("DD/MM/YYYY") : "-"}`).join(",")
        : "-";
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
    filterable: false,
  },
  {
    field: "variousTraining",
    headerName: "Various Training",
    sortable: true,
    minWidth: 120,
    flex: 1,
    hideable: true,
    valueGetter: (row) => {
      const various_training = row.value;
      return various_training && Array.isArray(various_training)
        ? various_training
          .map(
            ({ training, typeOfTraining = "-", trainingDoneFrom, trainingDoneTo }) =>
              `${training ?? "-"}, ${typeOfTraining ?? "-"}, from ${trainingDoneFrom ? dayjs(trainingDoneFrom).format("DD/MM/YYYY") : "-"
              }, to ${trainingDoneTo ? dayjs(trainingDoneTo).format("DD/MM/YYYY") : "-"}`,
          )
          .join(" , ")
        : "-";
    },
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
    filterable: false,
  },

  {
    field: "qualification",
    headerName: "Qualification",
    sortable: true,
    minWidth: 120,
    flex: 1,
    hideable: true,
  },
  {
    field: "community",
    headerName: "Community",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
  },
  {
    field: "mobileNo",
    headerName: "Mobile Number",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
  },
  {
    field: "emailId",
    headerName: "Email Id",
    sortable: true,
    minWidth: 150,
    flex: 1,
    hideable: true,
    renderCell: (params) => <OverflowTip>{params.value}</OverflowTip>,
  },
  {
    field: "dateOfRetirement",
    headerName: "Date of Retirement",
    sortable: true,
    minWidth: 135,
    filterable: false,
    flex: 1,
    hideable: true,
    valueGetter: (params) => {
      const dor = params.value;
      if (!dor) {
        return "-";
      }
      return moment(dor, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    sortComparator: (d1, d2) => {
      return dayjs(d1, "DD/MM/YYYY").isBefore(dayjs(d2, "DD/MM/YYYY")) ? -1 : 1;
    },
  },
  {
    field: "pme",
    headerName: "PME",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
  },
  {
    field: "refresherDoneFrom",
    headerName: "Refresher Done From",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter(params) {
      return params.value ? moment(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "refresherDoneTo",
    headerName: "Refresher Done To",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter(params) {
      return params.value ? moment(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "pmeDoneFrom",
    headerName: "PME Done From",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter(params) {
      return params.value ? moment(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "pmeDoneTo",
    headerName: "PME Done To",
    sortable: true,
    minWidth: 135,
    flex: 1,
    hideable: true,
    valueGetter(params) {
      return params.value ? moment(params.value).format("DD/MM/YYYY") : "-";
    },
  },
];

const parseEmployeeInfoData = (infoData: any) => {
  const info = {
    "Employee Name": `${infoData?.firstName || ""} ${infoData?.lastName || ""}`,
    Designation: infoData?.designation || "-",
    "Group of Employee": infoData?.groupOfEmployee || "-",
    "Last Promotion/MACP Date": infoData?.lastPromotionDate || "-",
    "Post Code": infoData?.postCode || "-",
    "Bill Unit": infoData?.billUnit || "-",
    "PF No.": infoData?.pfNo || "-",
    "Pay Band": infoData?.payBand || "-",
    "Grade Pay": infoData?.gradePay || "-",
    "Pay Level": infoData?.payLevel || "-",
    "Basic Pay": infoData?.basicPay || "-",
    "TA Rate": infoData?.taRate || "-",
    "HRMS ID": infoData?.hrmsId || "-",
    "Revenue / Workcharge Post": infoData?.revenueWorkchargePost || "-",
    "Umid No": infoData?.umidNo || "-",
    "Aadhar No": infoData?.aadharNo || "-",
    "Covid Vaccination": infoData?.covidVaccination || "-",
    "FilledUp / Vacant / Downgraded": infoData?.filledUpVacantDowngraded || "-",
    "DPQ/DRQ": infoData?.dpqDrq || "-",
    "Grade of Incumbent": infoData?.gradeOfIncumbent || "-",
    "Date of Birth": infoData?.dob ? moment(infoData?.dob).format("DD/MM/YYYY") : "-",
    "Total Age as on date": infoData?.dob ? dayjs().diff(infoData.dob, "years").toString() : "-",
    "Age 55 Year attended (Yes/No)": infoData?.dob ? (dayjs().diff(infoData.dob, "years") > 55 ? "Yes" : "No") : "-",
    "Date of Appointment": infoData?.doa ? moment(infoData?.doa).format("DD/MM/YYYY") : "-",
    "Initial Place Of Posting with Date": `${infoData?.initialPlaceOfPosting}, ${infoData.initialDateOfPosting ? moment(infoData.initialDateOfPosting).format("DD/MM/YYYY") : "-"
      }`,
    "Previous Place of posting with date": `${infoData?.previousPlaceOfPosting}, ${infoData.previousPlaceOfPostingDate ? moment(infoData.previousPlaceOfPostingDate).format("DD/MM/YYYY") : "-"
      }`,
    "Current Place of posting with date": `${infoData?.currentPlaceOfPosting}, ${infoData.currentPlaceOfPostingDate ? moment(infoData.currentPlaceOfPostingDate).format("DD/MM/YYYY") : "-"
      }`,
    "At same place Since": infoData?.atSamePlaceSince || "-",
    Punishment:
      infoData?.punishment && Array.isArray(infoData?.punishment) && infoData?.punishment.length > 0
        ? infoData?.punishment
          .map(
            ({ date, reason, typeOfPunishment = "-", typeOfPenalty = "-" }: any, idx: number) =>
              `${idx + 1}) ${date ? moment(date).format("DD/MM/YYYY") : "-"}, ${typeOfPunishment} ${typeOfPenalty}`,
          )
          .join("\n")
        : "-",
    // MACP: infoData?.macp,
    Awards:
      infoData?.award && Array.isArray(infoData?.award) && infoData?.award.length > 0
        ? infoData?.award
          .map(({ name, date }: any) => `${name}, ${date ? dayjs(date).format("DD/MM/YYYY") : "-"}`)
          .join(",")
        : "-",
    // "Last refresher done on": infoData?.lastRefresherDoneOn
    //   ? moment(infoData?.lastRefresherDoneOn).format("DD/MM/YYYY")
    //   : "-",
    "Various Training":
      infoData?.variousTraining && Array.isArray(infoData?.variousTraining)
        ? infoData?.variousTraining
          .map(
            ({ training, typeOfTraining = "-", trainingDoneFrom, trainingDoneTo }: any) =>
              `${training}, ${typeOfTraining}, from ${trainingDoneFrom ? dayjs(trainingDoneFrom).format("DD/MM/YYYY") : "-"
              } to ${trainingDoneTo ? dayjs(trainingDoneTo).format("DD/MM/YYYY") : "-"}`,
          )
          .join("\n")
        : "-",
    Qualification: infoData?.qualification || "-",
    Community: infoData?.community || "-",
    "Mobile Number": infoData?.mobileNo || "-",
    "Email Id": infoData?.emailId || "-",
    "Date of Retirement": !infoData?.dateOfRetirement
      ? "-"
      : moment(infoData?.dateOfRetirement, "YYYY-MM-DD").format("DD/MM/YYYY"),
    // "Date of joining in group B": infoData?.dateOfJoiningInGroupB
    //   ? moment(infoData?.dateOfJoiningInGroupB).format("DD/MM/YYYY")
    //   : "-",
    PME: infoData?.pme || "-",
    "Work Position": infoData?.workPosition || "-",
    "Refresher Done From": infoData?.refresherDoneFrom ? moment(infoData?.refresherDoneFrom).format("DD/MM/YYYY") : "-",
    "Refresher Done To": infoData?.refresherDoneTo ? moment(infoData?.refresherDoneTo).format("DD/MM/YYYY") : "-",
    "PME Done From": infoData?.pmeDoneFrom ? moment(infoData?.pmeDoneFrom).format("DD/MM/YYYY") : "-",
    "PME Done To": infoData?.pmeDoneTo ? moment(infoData?.pmeDoneTo).format("DD/MM/YYYY") : "-",
  };
  return info;
};

type IInitialState = {
  data: any[];
  infoData: Record<string, string> | null;
  totalElements: number;
};

const initialState: IInitialState = {
  data: [],
  infoData: null,
  totalElements: 0,
};

const initialFilters = {
  name: null,
  email: null,
  designation: null,
};

function EmployeeBioData() {
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [employeeBiodataTableLoader, setEmployeeBiodataTableLoader] = useState(false);
  const [initialHiddenColumns, setIntialHiddenColumns] = useState({});
  const [showInfo, setShowInfo] = useState(false);

  const [state, setState] = useImmer<IInitialState>(initialState);
  const [filter, setFilter] = useState({});
  const [selectedEmployeeBiodata, setSelectedEmployeeBiodata] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [showAddEmployeeBiodataModal, setShowAddEmployeeBiodataModal] = useState(false);
  const navigate = useNavigate();
  const AUTHORITY = getLocalStorage("authority");
  const isAdmin = AUTHORITY === "admin";

  const EmployeeTableActionColumn = (params: any) => (
    <>
      {isAdmin && (
        <Tooltip placement="bottom" title={<div className="tooltip--title">Edit</div>} disableInteractive>
          <GridActionsCellItem
            icon={<EditIcon />}
            style={{ color: "#3B71CA" }}
            label="edit"
            onClick={() => {
              setSelectedEmployeeBiodata(params.row);
              setShowAddEmployeeBiodataModal(true);
              setIsUpdating(false);
            }}
          />
        </Tooltip>
      )}

      <Tooltip placement="bottom" title={<div className="tooltip--title">Info</div>} disableInteractive>
        <GridActionsCellItem
          icon={<InfoIcon color="primary" />}
          // style={{ color: "#54B4D3" }}
          label="Info"
          onClick={() => {
            const info = parseEmployeeInfoData(params.row);
            setState((draft: any) => {
              draft.infoData = info;
            });
            setShowInfo(true);
          }}
        />
      </Tooltip>

      <Tooltip placement="bottom" title={<div className="tooltip--title">History</div>} disableInteractive>
        <GridActionsCellItem
          icon={<History color="primary" />}
          label="History"
          onClick={() => {
            navigate("../employeebiodatahistory/" + params.row.id);
          }}
        />
      </Tooltip>

      {isAdmin && (
        <Tooltip placement="bottom" title={<div className="tooltip--title">Update</div>} disableInteractive>
          <GridActionsCellItem
            icon={<EditRoad />}
            style={{ color: "#3B71CA" }}
            label="edit"
            onClick={() => {
              setSelectedEmployeeBiodata(params.row);
              setShowAddEmployeeBiodataModal(true);
              setIsUpdating(true);
            }}
          />
        </Tooltip>
      )}
    </>
  );

  useEffect(() => {
    getEmployeeBiodata(filter);
  }, [page, pageSize, filter]);

  const getEmployeeBiodata = async (filter: any) => {
    try {
      setEmployeeBiodataTableLoader(true);
      let _filter = { ...filter, page, pageSize };
      _filter = extractFilters(_filter);
      let url = `${APP_BASE_URL}${MCDO_EMPLOYEE_BIODATA}?${_filter}`;
      const res = await axios.get(url);
      setState((state) => {
        state.data = res.data.data.content;
        state.totalElements = res.data.data?.totalElements || 0;
      });
    } catch (error: any) {
      setState((state) => {
        state.data = [];
        state.totalElements = 0;
      });
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong! Try again later!");
        return;
      }

      toast.error(error?.message || "Something went wrong! Try again later!");
    } finally {
      setEmployeeBiodataTableLoader(false);
    }
  };

  const getEmployeeBiodataTableColumns: () => GridColDef[] = () => {
    return [
      {
        field: "editActions",
        type: "actions",
        headerName: "Actions",
        minWidth: 185,
        filterable: false,
        renderCell: EmployeeTableActionColumn,
      },
      ...employeeBiodataFixedColumns,
    ];
  };

  const filterBiodata = (filter: any) => {
    setFilter((oldFilter) => ({ ...oldFilter, ...filter }));
    setPage(0);
  };

  const employeeBiodataTableColumns = useMemo(() => getEmployeeBiodataTableColumns(), []);

  return (
    <div className="page-container--card">
      {showInfo && <ViewInfoPopup label="Employee Biodata" open onClose={setShowInfo} infoData={state.infoData} />}
      <div className="flex justify-between">
        <Typography variant="h5" sx={{ fontWeight: "bold" }} textAlign={"start"}>
          Employees Biodata
        </Typography>
        {isAdmin && (
          <Button
            variant="contained"
            onClick={() => setShowAddEmployeeBiodataModal(true)}
            className="create-user-button"
          >
            Add new Employee
          </Button>
        )}
      </div>

      <EmployeeBioDataFilter initialFilters={initialFilters} filter={filter} onFilter={filterBiodata} />

      <DataTable
        tableInfo={{
          id: `employee-biodata-table`,
          label: `Employee-Biodata`,
          requireAuthSign: false,
          timestamp: { startTs: null, endTs: null },
        }}

        loading={employeeBiodataTableLoader}
        rows={state.data}
        columns={employeeBiodataTableColumns}
        rowCount={state.totalElements}
        pageSize={pageSize}
        pageSizeChange={setPageSize}
        pageIndex={page}
        pageChange={setPage}
        hideExportPDF={true}
        paginationMode="server"
        columnVisibilityModel={initialHiddenColumns}
      />
      {showAddEmployeeBiodataModal && (
        <EmployeeBiodataFormModal
          disableEditField={isUpdating}
          label={selectedEmployeeBiodata ? "Edit Employee Bio Data" : "Add Employee Bio Data"}
          initialBioData={selectedEmployeeBiodata}
          open
          onClose={(byCross: boolean) => {
            setShowAddEmployeeBiodataModal(false);
            setSelectedEmployeeBiodata(null);
            setIsUpdating(false);
            if (byCross) return;
            getEmployeeBiodata(filter);
          }}
        />
      )}
    </div>
  );
}

export default EmployeeBioData;
